<script setup lang="ts">
import type { NovaCreateHashtagMenuProps } from './NovaCreateHashtagMenu.types'

withDefaults(defineProps<NovaCreateHashtagMenuProps>(), {
  activeIndex: 0,
  index: 0,
})
</script>

<template>
  <li :class="['hashtag-menu', index === activeIndex ? 'active ' : '']">
    <span class="label">{{ item }}</span>
  </li>
</template>

<style lang="scss" scoped>
.hashtag-menu {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: auto;
  min-height: 32px;
  color: $color-black-60p;
  padding: 6px 12px;

  @include transition(all 0.15s ease-in-out);

  &:hover,
  &:focus,
  &.active {
    background-color: $color-black-3p;
  }

  > .label {
    font-size: 12px;
    font-weight: 400;
    text-align: left;
  }
}
</style>
